import React, { Component } from 'react';
import { Table, message } from 'antd';
import UpdateScore from './UpdateScore';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import Filter from './Filter';

class StaffScore extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1, 
            pageSize: 10,
        },
        data: [],
        config: {},
        loading: false,
        canSynchronize: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        const options = {
            url: API_URL.hospital.querySsuMemberScoreGradeList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams, 
            },
            dataType: 'json',
            doneResult: res => {
                const { data = {}, datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;
                const { canEdit, canSynchronize } = data;
                searchParams.canEdit = canEdit == 'true';
                this.setState({
                    pagination,
                    data: datas,
                    searchParams,
                    config: data,
                    loading: false,
                    canSynchronize: canSynchronize == 'true',
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    synchronizeUser = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.hospital.createSsuMemberUser,
            data: {},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, searchParams } =  this.state;
        ExportUtil.export(searchParams, pagination, API_URL.hospital.exportSsuMemberScoreGradeList);
    }

    getColumns = () => {
        const { curRole } = sessionStorage;
        const { searchParams: { canEdit } } = this.state;
        const isBO = curRole == 'BO';
        const columns = [
            {
                title: '考核时间',
                dataIndex: 'inspectionTime',
                key: 'inspectionTime',
                sorter: !isBO,
                fixed: 'left',
                width: 85,
                render: (text) => text ? text.slice(0, 7) : '',
            }, {
                title: 'SSU姓名',
                dataIndex: 'ssuCompellation',
                key: 'ssuCompellation',
                fixed: 'left',
                width: 90,
            }, {
                title: 'SSU工号',
                dataIndex: 'ssuCode',
                key: 'ssuCode',
                fixed: 'left',
                sorter: isBO,
                width: 90,
            }, {
                title: '团队贡献评分',
                children: [{
                    title: 'SSU经验分享',
                    dataIndex: 'ssuExperienceSharing',
                    key: 'ssuExperienceSharing',
                }, {
                    title: '正能量宣传',
                    dataIndex: 'positivePublicity',
                    key: 'positivePublicity',
                }, {
                    title: 'SSU业务宣传',
                    dataIndex: 'ssuBusinessPromotion',
                    key: 'ssuBusinessPromotion',
                }, {
                    title: '合计',
                    dataIndex: 'teamContributionScore',
                    key: 'teamContributionScore',
                }]
            }, {
                title: 'SSU工作失误评分',
                children: [{
                    title: '当月被投诉',
                    dataIndex: 'monthComplained',
                    key: 'monthComplained',
                }, {
                    title: '因SSU人员造成进度延误',
                    dataIndex: 'ssuProgressDelayed',
                    key: 'ssuProgressDelayed',
                }, {
                    title: '因SSU人员影响公司合作',
                    dataIndex: 'ssuWorkAffected',
                    key: 'ssuWorkAffected',
                }, {
                    title: '合计',
                    dataIndex: 'ssuErrorWorkContributionScore',
                    key: 'ssuErrorWorkContributionScore',
                }]
            }, {
                title: 'BO总结性评语',
                dataIndex: 'summaryRemark',
                key: 'summaryRemark',
                width: 200,
            }, {
                title: '评价人',
                dataIndex: 'appraiseUser',
                key: 'appraiseUser',
                width: 80,
            }, {
                title: '评价时间',
                dataIndex: 'appraiseTime',
                key: 'appraiseTime',
                width: 80,
            }
        ];
        if (canEdit && isBO) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                fixed: 'right',
                width: 60,
                render: (text, record) => {
                    return <a onClick={() => this.updateScore(record)}>加减分</a>
                }
            })
        }
        return columns;
    }
 
    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => {
            const appraiseUser =
                item.appraiseCompellation ?
                    <span>
                        {item.appraiseCompellation}
                        <br />
                        {item.appraiseCode ? `(${item.appraiseCode})` : ''}
                    </span>
                : '';
            const params = {
                ...item,
                appraiseUser,
            };
            return params;
        });
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    updateScore = (record) => {
        this.UpdateScoreRef.show({ ...record });
    }

    render() { 
        const { config, loading, pagination, canSynchronize } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='staffScore' />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        canSynchronize={canSynchronize}
                        synchronizeUser={this.synchronizeUser}
                    />
                    <div className="main-content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.ssuMemberScoreGradeId}
                            loading={loading}
                            scroll={{x: 1655}}
                            onChange={this.handleTableChange}
                            pagination={ pagination }
                        />
                    </div>
                    <UpdateScore config={config} loadData={this.loadData} ref={el => this.UpdateScoreRef = el} />
                </div>
            </div>
        );
    }
}

export default StaffScore;


// WEBPACK FOOTER //
// ./src/components/hospital/StaffScore/index.js